import { MY_APPS_LINK } from '../../../../config/Constants'
import { PopupError } from '../../popups/PopupError'
import getText from '../../i18n/labels'

/**
 * Ritorna una modale di errore notificando all'utente che il certificato è scaduto e un link per rinnovarlo
 *
 * @param {{language: string, link: string}} [options]
 * @param {string} [language=it] - La lingua del messaggio.
 * @param {string} [link=MY_APPS_LINK] - Il link per acquistare o rinnovare la licenza.
 * @return {ReactElement} Il componente PopupError.
 */
export function LicenseExpiredPopup({ language = 'it', link = MY_APPS_LINK }) {
  const labels = getText(language)
  return PopupError({
    text: labels.EXPIRED_LICENCE(link)
  })
}
